var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#EC5BB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8085 19.9465C26.18 20.0827 26.3658 20.1508 26.5401 20.2409C26.6948 20.3208 26.8427 20.4136 26.9819 20.5182C27.1388 20.636 27.2809 20.7737 27.5651 21.0492L39.4875 32.6025C40.655 33.7338 40.6843 35.5974 39.5529 36.7649C38.4216 37.9324 36.558 37.9617 35.3905 36.8303L23.4681 25.2771C23.1839 25.0016 23.0418 24.8639 22.9191 24.7109C22.8101 24.5749 22.7128 24.4301 22.628 24.278C22.5325 24.1066 22.4586 23.9231 22.3107 23.5559L19.9989 17.8162L25.8085 19.9465Z",
    fill: "#FFEEF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6009 19.8704C26.0018 20.0174 26.2023 20.0909 26.2956 20.2209C26.3771 20.3345 26.4095 20.4761 26.3855 20.6139C26.3579 20.7715 26.2094 20.9249 25.9122 21.2315L23.5983 23.6193C23.3012 23.9259 23.1526 24.0792 22.9959 24.1117C22.859 24.1401 22.7164 24.1122 22.6003 24.0342C22.4674 23.945 22.3876 23.747 22.2281 23.3509L19.9989 17.8162L25.6009 19.8704Z",
    fill: "#FFEEF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9989 17.8162L22.3107 23.5559C22.4586 23.9231 22.5325 24.1066 22.628 24.278C22.7128 24.4301 22.8101 24.5749 22.9191 24.7109C23.0418 24.8639 23.1839 25.0016 23.4681 25.2771L35.3905 36.8303C36.558 37.9617 38.4216 37.9324 39.5529 36.7649C40.6843 35.5974 40.655 33.7338 39.4875 32.6025L27.5651 21.0492C27.2809 20.7737 27.1388 20.636 26.9819 20.5182C26.8427 20.4136 26.6948 20.3208 26.5401 20.2409C26.3658 20.1508 26.18 20.0827 25.8085 19.9465L19.9989 17.8162ZM19.9989 17.8162L25.6009 19.8704C26.0018 20.0174 26.2023 20.0909 26.2956 20.2209C26.3771 20.3345 26.4095 20.4761 26.3855 20.6139C26.3579 20.7715 26.2094 20.9249 25.9122 21.2315L23.5983 23.6193C23.3012 23.9259 23.1526 24.0792 22.9959 24.1117C22.859 24.1401 22.7164 24.1122 22.6003 24.0342C22.4674 23.945 22.3876 23.747 22.2281 23.3509L19.9989 17.8162Z",
    stroke: "#FFEEF8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.7644C10.0414 30.1619 10.6213 30.562 10.8517 30.8624C11.5315 31.7482 12.162 32.6709 12.8352 33.5625C13.8567 34.915 14.8335 36.376 15.6471 37.8534C16.2055 38.8674 16.9897 40.0778 17.1405 41.2369C17.1587 41.3763 17.5079 40.3579 17.5606 40.2062C18.1483 38.5131 19.0777 36.952 19.9408 35.3774C23.7828 28.3678 33.4486 17.295 38.75 11.25",
    stroke: "#FFEEF8",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveIconColour);
export default __webpack_public_path__ + "static/media/InteractiveIconColour.f47e10ac9811225c7880f1ee11231913.svg";
export { ForwardRef as ReactComponent };